import React from "react";
import {AdditionalServiceModel} from "../../../../shared/models/order/additional-service.model";
import {OrderModel} from "../../../../shared/models/order/order-item.model";
import {AddressDialog} from "./service-dialogs/additional-service-address-dialog";
import {OnHoldDialog} from "./service-dialogs/additional-service-on-hold-dialog";

export const AdditionalServiceDialog = ({service, order, open, isNewOrder, handleClose, updateData, additionalServiceData}: AdditionalServiceDialogProps) => {
    switch (service.additionalServiceId) {
        case 1: // check_the_package_contents
            return <></>
        case 2: // additional_packaging
            return <></>
        case 3: // change_receiver
            return <></>
        case 4: // divide_package
            return <></>
        case 5: // home_delivery
            return <AddressDialog order={order}
                                  open={open}
                                  updateData={updateData}
                                  isNewOrder={isNewOrder}
                                  handleClose={handleClose}/>;
        case 6: // on_hold
            return <OnHoldDialog order={order}
                                 updateData={updateData}
                                 isOnHold={additionalServiceData?.isOnHold}
                                 open={open}
                                 handleClose={handleClose}/>;
        default:
            return <></>
    }
}

interface AdditionalServiceDialogProps {
    service: AdditionalServiceModel,
    order: OrderModel,
    updateData?: {[key: string]: any}
    open: boolean,
    isNewOrder: boolean,
    handleClose: (withChange: boolean, existingOrderUpdates?: any) => void,
    additionalServiceData?: {[key: string]: any}
}